import { RootState } from '../reducers';
import { displayConfig } from '@config/constants';
import { User } from '@api/types.generated';

export const getAuthUser = (state: RootState): User | null => state.auth.user;
export const getAuthUserId = (state: RootState): User['id'] | undefined => state.auth?.user?.id;
export const getUserIsLogged = (state: RootState): boolean => state.auth.user != null;
export const getLocale = (state: RootState): string =>
  state.auth?.user?.locale || displayConfig.defaultLocale;
export const isAdmin = (state: RootState): boolean => (state.auth?.user?.isAdmin || false);
export const getUserGroupPlaceCode = (state: RootState): string | undefined => state.auth?.user?.group?.placeCode;
